// Dependencies
import React from 'react'
import { NavLink } from "react-router";

const ButtonFull = (props) => {
  return (
    <NavLink to={props.navigationURL} className={`bg-[#06BD60] text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer ${props.overrideStyles}`}>
        {props.buttonText}
    </NavLink>
  )
}

export default ButtonFull